import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query'
import { CardFeedsResponse } from 'src/queries/cardFeeds/cardFeeds.models'
import {
  CardFeedsQueryParams,
  fetchCardFeeds,
} from 'src/queries/cardFeeds/network/cardFeeds.network'
import {
  cardFeedsQueryKeys,
  queryCacheOptions,
} from 'src/queries/queries.constants'

const useQueryCardFeeds = (
  organizationId: string | undefined,
  enabled = true,
  view?: CardFeedsQueryParams,
): UseQueryResult<CardFeedsResponse> =>
  useQuery({
    // Only append `view` when it's defined so the unfiltered list key stays
    // `cardFeedsQueryKeys.list(organizationId)` — same key shape as other
    // list-with-filters patterns in the repo.
    queryKey: view
      ? [...cardFeedsQueryKeys.list(organizationId), view]
      : cardFeedsQueryKeys.list(organizationId),
    queryFn: async (): Promise<CardFeedsResponse> => {
      return fetchCardFeeds(organizationId as string, view)
    },
    enabled: enabled && organizationId !== undefined,
    // Always refetch on mount; CardFeedsTable additionally gates the empty-org
    // redirect on isFetchedAfterMount so it never acts on a prior visit's data.
    ...queryCacheOptions({ staleTime: 0 }),
    refetchOnMount: 'always',
    placeholderData: keepPreviousData,
  })

export default useQueryCardFeeds
